module.exports = __webpack_public_path__ + "img/add_location.9cd301ec.svg";